export default "__VITE_ASSET__sUmm5u5e__"